import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const DashboardPage = lazy(() => import('~/features/dashboard/pages/dashboard-page'));

export const Route = createFileRoute('/_authenticated/_tenant/dashboard')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <DashboardPage />
    </Suspense>
  ),
});
